import { DataFormToolbarDefaultButtons } from "./data-form-toolbar-default-buttons";
import { DataFormToolbarLayout } from "./data-form-toolbar-layout";

export function DataFormDefaultToolbar() {
  return (
    <DataFormToolbarLayout>
      <DataFormToolbarDefaultButtons />
    </DataFormToolbarLayout>
  );
}
